import { render, staticRenderFns } from "./SocialMediaLogin.vue?vue&type=template&id=3f422b98&scoped=true"
import script from "./SocialMediaLogin.vue?vue&type=script&lang=js"
export * from "./SocialMediaLogin.vue?vue&type=script&lang=js"
import style0 from "./SocialMediaLogin.vue?vue&type=style&index=0&id=3f422b98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f422b98",
  null
  
)

export default component.exports